import { render, staticRenderFns } from "./StatementItem.vue?vue&type=template&id=15482d56"
import script from "./StatementItem.vue?vue&type=script&lang=js"
export * from "./StatementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports